import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { FaBoxOpen, FaSitemap } from "react-icons/fa";

const AddChoiceModal = ({ show, onAddProduct, onAddSubCategory, onCloseClick }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-4 px-5 text-center">
        <div>
  <div className="mt-3">
    <h4 className="fw-semibold">Choose an Option</h4>
    <p className="text-muted mb-0">
      Do you want to add a <b>sub-category</b> or <b>product</b> under this category?
    </p>

    <p className="text-warning mt-2 fw-semibold">
      <i className="ri-alert-line me-1"></i>
      If you add products under this category, you cannot add subcategories under it.
    </p>
  </div>
</div>


        <div className="d-flex justify-content-center gap-3 mt-4">
          <button
            type="button"
            className="btn btn-outline-success d-flex align-items-center gap-2"
            onClick={onAddProduct}
          >
            <FaBoxOpen size={18} />
            Add Product
          </button>

          <button
            type="button"
            className="btn btn-outline-primary d-flex align-items-center gap-2"
            onClick={onAddSubCategory}
          >
            <FaSitemap size={18} />
            Add Sub-Category
          </button>
        </div>

        <div className="mt-4">
          <button
            type="button"
            className="btn btn-light w-100"
            onClick={onCloseClick}
          >
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

AddChoiceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onAddProduct: PropTypes.func.isRequired,
  onAddSubCategory: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default AddChoiceModal;
